/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as WeeksRouteImport } from "./routes/weeks"
import { Route as TimelineRouteImport } from "./routes/timeline"
import { Route as TermsRouteImport } from "./routes/terms"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as ProfileIndexRouteImport } from "./routes/profile/index"
import { Route as UIdentifierRouteImport } from "./routes/u.$identifier"
import { Route as TraderAddressRouteImport } from "./routes/trader.$address"
import { Route as ProfileEditRouteImport } from "./routes/profile/edit"
import { Route as PastWeekIdRouteImport } from "./routes/past.$weekId"
import { Route as MarketsMarketIdRouteImport } from "./routes/markets/$marketId"

const WeeksRoute = WeeksRouteImport.update({
  id: "/weeks",
  path: "/weeks",
  getParentRoute: () => rootRouteImport,
} as any)
const TimelineRoute = TimelineRouteImport.update({
  id: "/timeline",
  path: "/timeline",
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: "/terms",
  path: "/terms",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: "/profile/",
  path: "/profile/",
  getParentRoute: () => rootRouteImport,
} as any)
const UIdentifierRoute = UIdentifierRouteImport.update({
  id: "/u/$identifier",
  path: "/u/$identifier",
  getParentRoute: () => rootRouteImport,
} as any)
const TraderAddressRoute = TraderAddressRouteImport.update({
  id: "/trader/$address",
  path: "/trader/$address",
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileEditRoute = ProfileEditRouteImport.update({
  id: "/profile/edit",
  path: "/profile/edit",
  getParentRoute: () => rootRouteImport,
} as any)
const PastWeekIdRoute = PastWeekIdRouteImport.update({
  id: "/past/$weekId",
  path: "/past/$weekId",
  getParentRoute: () => rootRouteImport,
} as any)
const MarketsMarketIdRoute = MarketsMarketIdRouteImport.update({
  id: "/markets/$marketId",
  path: "/markets/$marketId",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/terms": typeof TermsRoute
  "/timeline": typeof TimelineRoute
  "/weeks": typeof WeeksRoute
  "/markets/$marketId": typeof MarketsMarketIdRoute
  "/past/$weekId": typeof PastWeekIdRoute
  "/profile/edit": typeof ProfileEditRoute
  "/trader/$address": typeof TraderAddressRoute
  "/u/$identifier": typeof UIdentifierRoute
  "/profile/": typeof ProfileIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/terms": typeof TermsRoute
  "/timeline": typeof TimelineRoute
  "/weeks": typeof WeeksRoute
  "/markets/$marketId": typeof MarketsMarketIdRoute
  "/past/$weekId": typeof PastWeekIdRoute
  "/profile/edit": typeof ProfileEditRoute
  "/trader/$address": typeof TraderAddressRoute
  "/u/$identifier": typeof UIdentifierRoute
  "/profile": typeof ProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/terms": typeof TermsRoute
  "/timeline": typeof TimelineRoute
  "/weeks": typeof WeeksRoute
  "/markets/$marketId": typeof MarketsMarketIdRoute
  "/past/$weekId": typeof PastWeekIdRoute
  "/profile/edit": typeof ProfileEditRoute
  "/trader/$address": typeof TraderAddressRoute
  "/u/$identifier": typeof UIdentifierRoute
  "/profile/": typeof ProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/terms"
    | "/timeline"
    | "/weeks"
    | "/markets/$marketId"
    | "/past/$weekId"
    | "/profile/edit"
    | "/trader/$address"
    | "/u/$identifier"
    | "/profile/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/terms"
    | "/timeline"
    | "/weeks"
    | "/markets/$marketId"
    | "/past/$weekId"
    | "/profile/edit"
    | "/trader/$address"
    | "/u/$identifier"
    | "/profile"
  id:
    | "__root__"
    | "/"
    | "/terms"
    | "/timeline"
    | "/weeks"
    | "/markets/$marketId"
    | "/past/$weekId"
    | "/profile/edit"
    | "/trader/$address"
    | "/u/$identifier"
    | "/profile/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TermsRoute: typeof TermsRoute
  TimelineRoute: typeof TimelineRoute
  WeeksRoute: typeof WeeksRoute
  MarketsMarketIdRoute: typeof MarketsMarketIdRoute
  PastWeekIdRoute: typeof PastWeekIdRoute
  ProfileEditRoute: typeof ProfileEditRoute
  TraderAddressRoute: typeof TraderAddressRoute
  UIdentifierRoute: typeof UIdentifierRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/weeks": {
      id: "/weeks"
      path: "/weeks"
      fullPath: "/weeks"
      preLoaderRoute: typeof WeeksRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/timeline": {
      id: "/timeline"
      path: "/timeline"
      fullPath: "/timeline"
      preLoaderRoute: typeof TimelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/terms": {
      id: "/terms"
      path: "/terms"
      fullPath: "/terms"
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/profile/": {
      id: "/profile/"
      path: "/profile"
      fullPath: "/profile/"
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/u/$identifier": {
      id: "/u/$identifier"
      path: "/u/$identifier"
      fullPath: "/u/$identifier"
      preLoaderRoute: typeof UIdentifierRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/trader/$address": {
      id: "/trader/$address"
      path: "/trader/$address"
      fullPath: "/trader/$address"
      preLoaderRoute: typeof TraderAddressRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/profile/edit": {
      id: "/profile/edit"
      path: "/profile/edit"
      fullPath: "/profile/edit"
      preLoaderRoute: typeof ProfileEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/past/$weekId": {
      id: "/past/$weekId"
      path: "/past/$weekId"
      fullPath: "/past/$weekId"
      preLoaderRoute: typeof PastWeekIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/markets/$marketId": {
      id: "/markets/$marketId"
      path: "/markets/$marketId"
      fullPath: "/markets/$marketId"
      preLoaderRoute: typeof MarketsMarketIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TermsRoute: TermsRoute,
  TimelineRoute: TimelineRoute,
  WeeksRoute: WeeksRoute,
  MarketsMarketIdRoute: MarketsMarketIdRoute,
  PastWeekIdRoute: PastWeekIdRoute,
  ProfileEditRoute: ProfileEditRoute,
  TraderAddressRoute: TraderAddressRoute,
  UIdentifierRoute: UIdentifierRoute,
  ProfileIndexRoute: ProfileIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
